import styled from 'styled-components';

import { BaseStyle } from '@nhl/nhl-breakaway-ui';

import { SERIES_SLIDE_HEIGHT, SERIES_SLIDE_WIDTH } from '../styles';

const createGridTemplate = () => `
    grid-template:
        [game-info-row-start] 'series series' 10px[game-info-row-end]
        [spacer-row-start] 'spacer spacer' 8px[spacer-row-end]
        [team-logo-row-start] 'team1 team2' 46px[team-logo-row-end]
        / auto auto;
`;

export const TransparentSlideCover = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    place-self: stretch;

    background-color: ${({ theme }) => theme.Surface.Opposite.primary};
    opacity: 0.1;
    grid-area: game-info-row / series / team-logo-row / team2;
`;

export const HSBSeries = styled.a`
    ${createGridTemplate()};
    display: grid;
    align-items: center;
    place-content: center space-between;
    color: ${({ theme }) => theme.Text.primary};
    padding: 12px 12px 8px 12px;
    width: ${SERIES_SLIDE_WIDTH}px;
    height: ${SERIES_SLIDE_HEIGHT}px;

    ${TransparentSlideCover} {
        display: none;
    }

    &:hover {
        cursor: pointer;

        ${TransparentSlideCover} {
            display: flex;
            position: absolute;
            width: ${SERIES_SLIDE_WIDTH}px;
            height: ${SERIES_SLIDE_HEIGHT}px;
            left: 0;
            top: 0;
        }
    }
`;

export const Team = styled.div<{ $isLeftTeam: boolean }>`
    grid-area: ${({ $isLeftTeam }) => ($isLeftTeam ? 'team1' : 'team2')};

    .tricode-name {
        color: ${({ theme }) => theme.Text.secondary};
        ${BaseStyle.Mixins.fontStyles.ui['10bCaps']}
    }

    .team-logo {
        height: 24px;
        width: auto;
    }

    .team-display {
        flex-direction: column;
    }
`;

export const SeriesStatus = styled.div`
    ${BaseStyle.Mixins.fontStyles.ui['10m']}
    color: ${({ theme }) => theme.Text.primary};
    grid-area: series;
    width: 100%;
    justify-self: center;
    text-align: center;
`;
